import { render, staticRenderFns } from "./QuickTipSubNav.vue?vue&type=template&id=2fb82f14&scoped=true&"
import script from "./QuickTipSubNav.vue?vue&type=script&lang=js&"
export * from "./QuickTipSubNav.vue?vue&type=script&lang=js&"
import style0 from "./QuickTipSubNav.vue?vue&type=style&index=0&id=2fb82f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb82f14",
  null
  
)

export default component.exports